<template>
  <div class="demographicAge">
    <adx-list-item :data='data' :type="`bar`" />
  </div>
</template>

<script>
import ListItem from '@/components/ListDemographic'

import api from '@/api'
import { apiV2 } from '@/api/urls'
export default {
  name: 'adx-campaignreport-demographic-age',
  components: {
    'adx-list-item': ListItem
  },
  props: {

  },
  data() {
    return {
      data: {
        header: ['AGE', 'USER'],
        body: []
      }
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    this.loadData()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      const { status, data } = await api.get(apiV2.measurementcampaignReportDetail(this.$route.params.campaign_id), { needToken: true })
      if(status == 200) {
        let { get_all_age } = await data
        let {total_traffic} = await data
        this.data.body = Object.keys(get_all_age).map((key, index) => {
          let data = {}
          data.range = get_all_age[key].range,
          data.user = get_all_age[key].percentage,
          data.total = Math.round(get_all_age[key].percentage * total_traffic /100)
          return data
        })        
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>